const clientUrlParams = [
  'clientId',
  'company',
  'countryCode',
  'email',
  'firstName',
  'lastName',
  'partnerAccount',
  'partnerId',
  'campaignId',
  'leadId',
  'phone',
  'gsxid',
  'gspk',
  'mbsy',
  'gclid',
];

export default clientUrlParams;
